<template>
    <div class="container">
      <QueryFrame
        :add-text="handlePermission('addInfoRevisal')?'新增订正':''"
        @handlePage='handlePage'
        @handlePageSize='handlePageSize'
        @addNew='addNew'
        :count= 'count'
        :current="page"
      >
        <div slot="queryParams" class="form">
          <div class="queryContainer">
            <div class="queryItem">
              <label>操作时间:</label>
              <timeStampDatePicker type='daterange' class="item" placeholder=" 请选择" clearable v-model='query.duration' />
            </div>
            <div class="queryItem">
              <label>商品:</label>
              <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model="query.nameMix"></lk-input>
            </div>
            <div class="queryItem">
              <label>批次号:</label>
              <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model="query.batchSeq"></lk-input>
            </div>
            <div class="queryItem">
              <lk-button class="mr" type="primary" @click="gotoHandleSearch">查询</lk-button>
              <lk-button @click="clear">重置</lk-button>
            </div>
          </div>
        </div>

        <div slot="table">
          <lk-table border :columns="columns" :data="tableData"></lk-table>
        </div>
      </QueryFrame>
    </div>
    </template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import timeStampDatePicker from '../../components/timeStampDatePicker.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import toolsService from '../../services/tools';

export default {
  name: 'informationRevisal',
  mixins: [mapState, queryMixins],
  data() {
    return {
      size: 20,
      query: {
        nameMix: '',
        batchSeq: '',
        operateBeginTime: '',
        operateEndTime: '',
        duration: [],
      },
      columns: [
        { title: '序号', type: 'index', minWidth: 60 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '修改状态', key: 'statusName', minWidth: 116 },
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '批次号', key: 'batchSeq', minWidth: 116 },
        {
          title: '修改内容',
          key: 'contents',
          minWidth: 300,
          render: (h, params) => h('span', params.row.contents.length > 0 ? params.row.contents.join(',') : ''),
        },
        { title: '操作人', key: 'createUserName', minWidth: 116 },
        {
          title: '操作时间',
          key: 'createTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.createTime)),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    addNew() {
      this.$router.push({ name: 'addInfoRevisal' });
    },
    getData() {
      const params = utils.deepClone(this.query);
      params.page = this.page;
      params.size = this.size;
      toolsService.dateRevisalList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list;
          this.count = res.data.data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    gotoHandleSearch() {
      if (this.query.duration != undefined && this.query.duration.length == 2) {
        this.query.operateBeginTime = this.query.duration[0];
        this.query.operateEndTime = this.query.duration[1];
      } else {
        this.query.operateBeginTime = '';
        this.query.operateEndTime = '';
      }
      this.handleSearch();
    },
    clear() {
      this.query = {
        nameMix: '',
        batchSeq: '',
        operateBeginTime: '',
        operateEndTime: '',
        duration: [],
      };
    },
  },
  mounted() {
    this.handleSearch(true);
  },
  components: {
    QueryFrame,
    timeStampDatePicker,
  },
};
</script>

<style scoped>
</style>
